import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const tomi = [{
  emoji: '📘',
  title: 'Grundlagen der Industrieautomation',
  subtitle: '80 Seiten | Industrie 4.0 Standard Schweiz 2026',
  bullets: ['Einführung in die Automatisierung: Von manuell zu vollautomatisch', 'Industrie 4.0: Cyber-physische Systeme & digitale Zwillinge', 'Industrielle Variablen: Druck, Temperatur, Durchfluss, Niveau', 'Analoge vs. digitale Signale: 4–20 mA und 0–10 V in der Praxis', 'Reale Schweizer Industrieprozesse als Fallbeispiele', 'Druckfertige Arbeitsblätter und Evaluationen']
}, {
  emoji: '📗',
  title: 'SPS Grundlagen — Programmierung & Logik',
  subtitle: '80 Seiten | Siemens SIMATIC S7 / TIA Portal',
  bullets: ['Was ist eine SPS? Aufbau, Funktion und Typen', 'Ladder Logic von Null auf: Die Sprache der Automatisierung', 'Zeitglieder und Zähler: Praxisprojekte für den Unterricht', 'Siemens TIA Portal: Grundkonfiguration und erste Programme', 'Simulation industrieller Prozesse ohne teure Hardware', 'Reale Fallstudien aus der Schweizer Fertigungsindustrie']
}, {
  emoji: '📙',
  title: 'Industrielle Sensorik',
  subtitle: '80 Seiten | Messtechnik & Signalverarbeitung',
  bullets: ['Induktive, kapazitive und photoelektrische Sensoren', 'Temperatur-, Druck- und Niveausensoren in der Praxis', 'Anschlussschemata und Verdrahtung: praxisnah erklärt', 'Fehlerdiagnose bei Sensorsignalen: systematischer Ansatz', 'Reale Applikationen aus der Schweizer Industrie', 'Technische Übungen mit vollständigem Lösungsschlüssel']
}, {
  emoji: '📒',
  title: 'Pneumatik & Elektropneumatik',
  subtitle: '80 Seiten | Industrielle Antriebstechnik',
  bullets: ['Druckluft als Energieträger: Erzeugung, Aufbereitung, Verteilung', 'Zylinder und Ventile: Funktion, Auswahl, Dimensionierung', 'Elektropneumatische Schaltungen mit Magnetventilen', 'Pneumatische Schaltpläne lesen und zeichnen', 'Typische Störungen und systematische Fehlersuche', 'Praktische Übungen mit vollständigen Lösungen']
}, {
  emoji: '📓',
  title: 'Industrielle Steuerungssysteme — HMI & SCADA',
  subtitle: '80 Seiten | Digitale Steuerung & Überwachung',
  bullets: ['HMI-Panels: Aufbau, Projektierung, Bedienung im Unterricht', 'SCADA-Systeme: Visualisierung industrieller Anlagen', 'SPS-HMI Integration: Von der Programmierung zum Bedienpanel', 'Alarmsysteme und Prozessvisualisierung in der Praxis', 'Reale Fallstudien aus Schweizer Produktionsbetrieben', 'Diagnose und Optimierung von Steuerungsanlagen']
}, {
  emoji: '📔',
  title: 'Praxisprojekte Industrie 4.0',
  subtitle: '80 Seiten | Komplette Industrieprojekte',
  bullets: ['Vollständiges Projekt: Automatisierte Förderanlage', 'Projekt: Automatische Sortieranlage mit SPS-Steuerung', 'Motorsteuerung: Stern-Dreieck-Anlauf & Frequenzumrichter', 'Integrierte Simulation: Sensor → SPS → Aktuator → HMI', 'Geführte Projekte mit Schritt-für-Schritt-Anleitung', 'Fehlerbehebung und Troubleshooting in Echtszenarien']
}];
export function TomiSection() {
  return <section className="py-10 px-4 bg-brand-card-bg border-y border-gray-200" data-id="element-200">
      <div className="max-w-2xl mx-auto" data-id="element-201">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-center text-brand-charcoal mb-2" data-id="element-202">
          Was Sie erhalten: Die 6 Fachmodule
        </motion.h2>
        <p className="text-center text-sm text-gray-500 mb-8 font-medium" data-id="element-203">
          480 Seiten geballtes Praxiswissen — Industrie 4.0 ready
        </p>

        <div className="space-y-4" data-id="element-204">
          {tomi.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-white border border-gray-200 rounded-xl p-4 sm:p-6 shadow-sm" data-id="element-205">
              <div className="flex items-start gap-3 mb-3" data-id="element-206">
                <span className="text-3xl sm:text-4xl leading-none" data-id="element-207">
                  {t.emoji}
                </span>
                <div className="min-w-0 flex-1" data-id="element-208">
                  <div className="text-[11px] sm:text-xs font-bold text-brand-swiss-red uppercase tracking-wider mb-1" data-id="element-209">
                    MODUL {i + 1}
                  </div>
                  <h3 className="text-base sm:text-xl font-bold text-brand-charcoal leading-tight" data-id="element-210">
                    {t.title}
                  </h3>
                  <p className="text-[12px] sm:text-sm text-gray-500 mt-1 font-medium" data-id="element-211">
                    {t.subtitle}
                  </p>
                </div>
              </div>
              <div className="space-y-1.5 sm:space-y-2 mt-3" data-id="element-212">
                {t.bullets.map((bullet, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-213">
                    <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-green-cta shrink-0 mt-0.5" data-id="element-214" />
                    <span className="text-[13px] sm:text-base text-gray-700 leading-snug" data-id="element-215">
                      {bullet}
                    </span>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}